import {useEffect} from 'react';
import {useHistory} from 'react-router-dom';

const useOnNavigateAway = (rootPath: string, onNavigateAway: () => void) => {
  const history = useHistory();

  useEffect(
    () => () => {
      history.listen(listener => {
        const isNavigatingAwayFromRoot = !listener.pathname.includes(rootPath);

        if (isNavigatingAwayFromRoot) {
          onNavigateAway();
        }
      });
    },
    [rootPath, onNavigateAway]
  );
};

export default useOnNavigateAway;
